export const Arrow = () => (
  <svg
    className="fill-gray-90 absolute -bottom-1 left-1/2 block -translate-x-1/2 transform"
    width="10"
    height="5"
    viewBox="0 0 30 10"
    preserveAspectRatio="none"
  >
    <polygon points="0,0 30,0 15,10"></polygon>
  </svg>
);
